/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundModelSummary {
    getFixupPrototypeFunction() { return AIPlaygroundModelSummary.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundModelSummary>): AIPlaygroundModelSummary {
        let obj = Object.assign(new AIPlaygroundModelSummary(), model);
        AIPlaygroundModelSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundModelSummary>): AIPlaygroundModelSummary {
        if (!model) return null;
        return AIPlaygroundModelSummary.newInstance(<AIPlaygroundModelSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundModelSummary) {
        if (!obj) return;

        models.AIPlaygroundModelSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundModelSummary): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundModelSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Model ID
     */
    model_id: string;

    /**
     * Supported input modalities
     */
    input_modalities: Array<string>;

    /**
     * Display name
     */
    model_name: string;

    /**
     * Supported output modalities
     */
    output_modalities: Array<string>;

    /**
     * Model provider, extracted from model ID prefix
     */
    model_provider: string;

    /**
     * Model source type
     */
    model_type: models.AIPlaygroundModelType;

}
